import {
  translateDescription,
  translateShortDescription,
  translateTitle,
} from '../../lib/language';

export default {
  computed: {
    entryTitle() {
      return this.translateTitle(this.entry);
    },
    entryShortDescription() {
      return this.translateShortDescription(this.entry);
    },
    entryDescription() {
      return this.translateDescription(this.entry);
    },
  },
  methods: {
    translateTitle(obj) {
      return translateTitle(obj);
    },
    translateShortDescription(obj) {
      return translateShortDescription(obj);
    },
    translateDescription(obj) {
      return translateDescription(obj);
    },
  },
};
